import { IUser } from 'common/schema/User';
import moment from 'moment';
import { PermissionsType } from './Permissions';
import { Roles } from './Roles';

/**
 * Gestisce la logica di controllo dei permessi.
 */
export class PermissionLogic {
  /**
   * Controlla se il ruolo dell'utente da accesso al permesso richiesto.
   * In caso di più permessi,  controlla se il ruolo dell'utente
   * dà accesso ad **ALMENO UNO** dei permessi richiesti
   */
  static has(
    user: Maybe<IUser>,
    permission: PermissionsType | PermissionsType[]
  ) {
    if (!user) return false;
    return (
      Roles[user.role].hasPermission(permission) ||
      user.grants?.some(g => {
        if (g.expiresAt && moment(g.expiresAt).isBefore(new Date()))
          return false;

        return Array.isArray(permission)
          ? permission.some(p => g.permissions.includes(p))
          : g.permissions.includes(permission);
      })
    );
  }
}
